import { render, staticRenderFns } from "./VariantFilters.vue?vue&type=template&id=0a5def08"
import script from "./VariantFilters.ts?vue&type=script&lang=ts&external"
export * from "./VariantFilters.ts?vue&type=script&lang=ts&external"
import style0 from "./VariantFilters.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports